module.exports = __webpack_public_path__ + "img/horizontal_4_4_r_pp12_8017.64fb4ee0.png";